import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { IpModel } from '../../models/thirdparty/ip.model';
import { ThirdPartyRepository } from '../../repositories/thirdparty.repository';

export class GetIpUseCase implements UseCase<void, IpModel> {
    constructor(private thirdpaty: ThirdPartyRepository) { }
    execute(): Observable<IpModel> {
        return this.thirdpaty.getIp();
    }
}